import { render, staticRenderFns } from "./search.vue?vue&type=template&id=09ae9878&lang=pug&"
import script from "./search.vue?vue&type=script&lang=ts&"
export * from "./search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheNavbar: require('/app/components/the/TheNavbar.vue').default,SearchBar: require('/app/components/search-bar/SearchBar.vue').default,SearchBarFoldable: require('/app/components/search-bar/SearchBarFoldable.vue').default,FilterBar: require('/app/components/filter/FilterBar.vue').default,FilterSortMethod: require('/app/components/filter/FilterSortMethod.vue').default,GError: require('/app/components/GError.vue').default,GBtn: require('/app/components/GBtn.vue').default,StateMessage: require('/app/components/StateMessage.vue').default,ListCar: require('/app/components/ListCar.vue').default,Locations: require('/app/components/Locations.vue').default,SearchMap: require('/app/components/search/SearchMap.vue').default,SearchAside: require('/app/components/search/SearchAside.vue').default,BottomFixedModeSwitcher: require('/app/components/BottomFixedModeSwitcher.vue').default,FilterDialog: require('/app/components/filter/FilterDialog.vue').default,GLoading: require('/app/components/GLoading.vue').default,GRefreshSearchModal: require('/app/components/GRefreshSearchModal.vue').default,GView: require('/app/components/GView.vue').default})
